import * as echarts from 'echarts';
import { useEffect, useRef } from "react";

interface IProps {
    xAxis: any
    series: any
}
const ChartFishHealth: React.FC<IProps> = ({ xAxis = {}, series }) => {
    const chartRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (chartRef.current) {
            const existInstance = echarts.getInstanceByDom(chartRef.current)
            if (existInstance) echarts.dispose(chartRef.current)
            chartRef.current.style.height = series.length > 0 ? `30px` : `2px`;
            const chart = echarts.init(chartRef.current);
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        lineStyle: { width: 0 }
                    }
                },
                grid: {
                    top: 0,
                    height: 32,
                    right: '20px',
                    bottom: 0,
                },
                xAxis: {
                    ...xAxis,
                    show: false,
                },
                yAxis: {
                    type: 'category',
                    lineHeight: 30,
                    axisLabel: { show: false },
                    axisTick: { show: false },
                    axisLine: { show: false, },
                    name: '',
                },
                series
            };
            chart.setOption(option, true);
        }
    }, [series, xAxis])

    return <div ref={chartRef} style={{ height: `2px`, width: '100%' }} />
}

export default ChartFishHealth;